module.exports = __webpack_public_path__ + "static/img/industriesbg6.119dd27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industriesbg6.jpg
// module id = FfOz
// module chunks = 1